import { getNodeById } from "../../../../nodeSelector";
import * as nodeUtils from "../../../../utils/nodeUtils";
import * as systemUtils from "../../../../utils/systemUtils";

const _tagNodeTargetIndirect = "nodeTargetIndirect";
const _tagUuidTargetIndirect = "uuidTargetIndirect";
const _tagPayload = "refDesc";

//--------------------------------------------------------------------------------

export const getFunctionReferences = (root, node) => {
  const _results = {};

  const _nodeTargetIndirect = updateTargetIndirect(root, node);

  if (_nodeTargetIndirect) {
    _results[_tagNodeTargetIndirect] = _nodeTargetIndirect;
  }

  _results[_tagPayload] = describeReferences(_results);

  return _results;
};

export const processFunctionReferences = (references, funTargetIndirect = () => {}) => {
  const handler = references[_tagNodeTargetIndirect];
  if (handler) {
    handler.forEach(funTargetIndirect);
  }
};

//--------------------------------------------------------------------------------

const updateTargetDirect = (root, node) => {
  const _idTarget = nodeUtils.getIdTarget(node);

  if (!_idTarget) {
    return null;
  }

  const { data: _nodeTarget } = getNodeById(root, _idTarget);

  if (!_nodeTarget) {
    return null;
  }

  return { src: node, dst: _nodeTarget };
};

const updateTargetIndirect = (root, node) => {
  const _nodeTargetIndirect = [];

  const fun = (e) => {
    const _nodeTarget = updateTargetDirect(root, e);

    if (_nodeTarget) {
      _nodeTargetIndirect.push(_nodeTarget);
    }
  };

  nodeUtils.visitAllParameters(node, fun);

  return _nodeTargetIndirect.length > 0 ? _nodeTargetIndirect : null;
};

//--------------------------------------------------------------------------------

const describeReferences = (references) => {
  const _results = {};

  const funTarget = (e) => nodeUtils.getUUID(e.dst);

  const handler = references[_tagNodeTargetIndirect];
  if (handler) {
    _results[_tagUuidTargetIndirect] = systemUtils.removeDuplicates(handler.map(funTarget));
  }

  return _results;
};
